let Inits = [
  {
    rightnavs: '元素',
    id: 'gta_ai_event_item',
    title: '',
    content: '。',
    blockText: `<block type="gta_ai_event_item"></block>`,
  },
]
// 事件
let Events = [
  {
    rightnavs: '事件',
    id: 'gta_ai_event_print',
    title: '可嵌套积木的打印',
    blockText: `<block type="gta_ai_event_print">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>`,
    content: '第二个打印积木，可打印嵌套内的积木脚本',
  },
  {
    id: 'gta_ai_event_4',
    title: '执行代码（嵌套）',
    blockText: `<block type="gta_ai_event_4"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。积木的使用方式需要嵌套在其他积木内生效。',
  },
  {
    id: 'gta_ai_event_5',
    title: '执行代码（不可嵌套）',
    blockText: `<block type="gta_ai_event_5"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。',
  },
  {
    id: 'gta_define_robot_B',
    title: '连接一个机器人',
    content:
      '在同个局域网内，搜寻STA模式下的机器设备，并建立连接。参数：string类型，指代机器设备的名称（ID）默认值为 "robot"。返回无。',
    blockText: `<block type="gta_define_robot_B">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_close',
    title: '断开机器人连接',
    blockText: `<block type="gta_robot_B_close">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
    content: '断开机器人连接。无参数。无返回。',
  },

  {
    id: 'gta_robot_B_get_battery',
    title: '获取机器人电量',
    blockText: `<block type="gta_robot_B_get_battery">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
    content: '获取机器人电量。无参数。返回：0~100;返回剩余电量百分比。',
  },
  {
    id: 'gta_robot_B_get_version',
    title: '获取固件版本号',
    blockText: `<block type="gta_robot_B_get_version">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
    content: '获取机器人固件版本号。无参数。返回：固件版本号。',
  },
  {
    id: 'gta_ai_event_6',
    title: '显示',
    blockText: `<block type="gta_ai_event_6">
    <value name="NAME">
      <shadow type="gta_ai_event_item"> </shadow>
    </value>
  </block>`,
    content: '在显示区显示图片、文本、摄像头、音频等媒体。无返回',
  },
]

// 控制
let Control = [
  {
    rightnavs: '控制',
    id: 'controls_repeat_ext',
    title: '重复执行（）次',
    content:
      '重复执行是一个嵌套的积木，积木中间可以嵌套其他积木，嵌套的积木部分就是循环的内容。\n积木上面的数字为重复执行的次数，执行完毕后，再执行积木下方的脚本。',
    blockText: `<block type="controls_repeat_ext">
    <value name="TIMES">
      <shadow type="math_number">
        <field name="NUM">20</field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_controls_whileUntil',
    title: '如果…重复执行',
    blockText: `<block type="gta_controls_whileUntil">
    <value name="NAME1">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则重复执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'controls_for',
    title: '变量“i”从_数到_每次增加_',
    blockText: `<block type="controls_for">
    <value name="FROM">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
    <value name="TO">
      <shadow type="math_number">
        <field name="NUM">10</field>
      </shadow>
    </value>
    <value name="BY">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
  </block>`,
    content:
      '用变量”i”记录从开始数值到终止数值之间的数值，数值按指定间隔增加，并执行指定的块。',
  },
  {
    id: 'controls_forEach',
    title: '为列表_里的每一项_执行',
    blockText: `<block type="controls_forEach">
    <value name="LIST">
      <block type="variables_get">
        <field name="VAR">列表</field>
      </block>
    </value>
  </block>`,
    content: '遍历列表中的每一项，将变量“i”设为所选项，并执行一些语句。',
  },
  {
    id: 'break_continue',
    title: '跳出循环',
    blockText: `<block type="break_continue"></block>`,
    content: '跳出包含它的循环；需要注意的是这个块只能在循环内使用。',
  },
  {
    id: 'controls_if',
    title: '如果…那么',
    blockText: `<block type="controls_if">
    <value name="IF0">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'logic_negate',
    title: '非…',
    blockText: `<block type="logic_negate">
    <value name="BOOL">
      <shadow type="logic_null">
        <field></field>
      </shadow>
    </value>
  </block>`,
    content: '如果输入结果为假，则返回真；如果输入结果为真，则返回假。',
  },
  {
    id: 'logic_ternary',
    title: '断言__如果为真，__如果为假__',
    blockText: `<block type="logic_ternary">
    <value name="IF">
      <shadow type="logic_null"></shadow>
    </value>
    <value name="THEN">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
    <value name="ELSE">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
  </block>`,
    content:
      '检查“断言”里的条件语句。如果条件为真，则返回“如果为真”的值，否则，则返回“如果为假”的值。',
  },
  {
    id: 'waiting_time',
    title: ' 等待（）秒',
    blockText: `<block type="waiting_time"></block>`,
    content:
      '执行程序时，“等待1秒”，也可理解为“睡眠1秒”，适用于某些情况下需要人为让程序延迟的时候。',
  },
]

// 运算
let Operators = [
  {
    rightnavs: '运算',
    id: 'math_number',
    title: ' 一个数值',
    content: '一个数值，可以输入任意数值。',
    blockText: `<block type="math_number">
          <field name="NUM">123</field>
        </block>`,
  },
  {
    id: 'math_arithmetic_add',
    title: '数字运算',
    blockText: `<block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '四则运算，对数字进行加减乘除处理，加法还可以把字符串、列表相加。',
  },
  {
    id: 'logic_compare_1',
    title: '比较式',
    blockText: `<block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '比较表达式为布尔表达式，如果条件成立，则返回True，条件不成立则返回False。',
  },
  {
    id: 'logic_operation',
    title: '逻辑运算',
    blockText: `<block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>`,
    content:
      ' “并且”两边的条件同时成立，这个布尔表达式才算成立。\n“或”两边只要有一边条件成立，这个布尔值表达式就算成立。',
  },
  {
    id: 'logic_boolean',
    title: '逻辑运算：“非”',
    blockText: `<block type="logic_boolean"></block>`,
    content: '对当前的布尔表达式取反，如果当前表达式成立，则返回的值为不成立。',
  },
  {
    id: 'math_random_int',
    title: '随机整数',
    blockText: `<block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content:
      '1到10中随机取一个整数，区间[1,10]，前闭后闭，1和10两个值都有可能随机取到。',
  },
  {
    id: 'math_modulo',
    title: '除法求余数',
    blockText: `<block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '余数指整数除法中被除数未被除尽部分，且余数的取值范围为0到除数之间（不包括除数）的整数。例如：64除以10，商数为6，余数为4。',
  },
  {
    id: 'math_single',
    title: '绝对值',
    blockText: `<block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '绝对值是指一个数在数轴上所对应点到原点的距离，用“| |”来表示。\n正数和0的绝对值为它本身。\n负数的绝对值是它的相反数。',
  },
  {
    id: 'math_trig',
    title: '正弦值',
    blockText: `<block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>`,
    content: '返回指定角度的正弦值（非弧度）。',
  },
  {
    id: 'math_constant',
    title: '常见值',
    blockText: `<block type="math_constant"></block>`,
    content:
      ' 返回一个常见量：π（3.141…）、e（2.718…）、φ（1.618…）、平方根（1.414…）、开平方根（0.707…）或∞无限大”。',
  },
  {
    id: 'math_number_property',
    title: '检查数值属性',
    blockText: `<block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>`,
    content:
      ' 检查一个数值是否是偶数、奇数、质数、自然数、正数、负数或者是否能被某数整除。返回真或假。',
  },
  {
    id: 'math_round',
    title: '四舍五入',
    blockText: `<block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>`,
    content: '数值小数点后数字向上或向下舍入。',
  },
  {
    id: 'math_random_float',
    title: '随机小数',
    blockText: `<block type="math_random_float"></block>`,
    content: '返回一个介于0.0到1.0之间（含边界）的随机数。',
  },
  {
    id: 'math_on_list',
    title: '列表中数值的和',
    blockText: `<block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '返回列表中的所有数值的和。',
  },
  {
    id: 'math_constrain',
    title: '将数值限制在指定数值范围',
    blockText: `<block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content: '将一个数值限制在两个指定的数值范围（含边界）之间。',
  },
  {
    id: 'math_atan2',
    title: '反正切值',
    blockText: `<block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '返回点（X,Y）的反正切值，范围为-180度到180度。',
  },
]

// 变量
let Variable = [
  {
    rightnavs: '变量',
    id: 'variables_set',
    title: '赋值变量',
    blockText: `<block type="variables_set"></block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
  {
    id: 'math_change',
    title: '变量增加',
    content: `变量增加值。`,
    blockText: `<block type="math_change"></block>`,
  },
  {
    id: 'variables_get',
    title: '获取变量',
    blockText: `<block type="variables_get"> </block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
]

// 函数
let Function = [
  {
    rightnavs: '函数',
    id: 'procedures_defnoreturn',
    title: '定义无返回函数',
    content: `含义：
    1. 定义函数时，需要先定义函数的名称，点击上图中字母function所在的区域，就可以编 辑函数名。
    函数名需要满足以下几条规则：
    函数名可以同时包含字母和数字，但不能以数字开头。
    函数名中的字符必须是字母、数字、下划线或者汉字，不能使用其他字符。
    函数名区分大小写。
    函数不可以与关键词同名，同时为了防止一些理解上的误会，在积木模式下数名 不可以与任何Python其他内置函数同名。
    2. 要使用函数，光对函数进行定义可不行哦！函数定义只是构造了这个函数，要使函数真 正发挥作用，还要对函数进行调用，后面的部分会详细讲到如何调用函数。`,
    blockText: `<block type="procedures_defnoreturn"></block>`,
  },
  // {
  //   id: 'procedures_mutatorcontainer',
  //   title: '定义有返回函数',
  //   blockText: `<block type="procedures_mutatorcontainer"></block>`,
  //   content: '函数定义后，要调用它，函数才能发挥它的效果哦。',
  // },
  {
    id: 'procedures_defreturn',
    title: '输出值函数',
    blockText: `<block type="procedures_defreturn"></block>`,
    content: `含义：
    1. 创建一个有输出值的函数。
    2. 要将一个函数结束运行时得出的信息传递给程序的剩余部分，可以使用带“返回”的函数。
    3. 当运行到“返回”时，函数会停止运行，并返回对应表达式的值。
      有返回值的函数是椭圆型的哦，可以塞到其他的积木中，返回值能够被运行。`,
  },
  {
    id: 'procedures_ifreturn',
    title: '如果…..返回…..',
    blockText: `<block type="procedures_ifreturn"></block>`,
    content:
      '如果里面的值判断为真，则返回相关数值。提示：这个块只能在函数内部使用。',
  },
]

let Motion = [
  {
    rightnavs: '行驶',
    id: 'gta_robot_B_drive_wheels',
    title: '设置麦轮速度',
    content:
      '设置不同速度可以实现前进、后退、旋转、平移等运动。参数：左前轮速度、左后轮速度、右前轮速度、右后轮速度、几秒后停止运动。返回：设置成功返回True，失败返回False。',
    blockText: `<block type="gta_robot_B_drive_wheels">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_chassis_move',
    title: '设置运动路径',
    content:
      '设置路径规划。当前位置为原点，向X轴运动（0）厘米，向Y轴运动（0）厘米，然后旋转（0）角度。参数：1.向X轴运动（0）厘米,整数类型,-160~160;2.向Y轴运动厘米,整数类型,-160~160;3.旋转（）角度,整数类型,-180~180。无返回。',
    blockText: `<block type="gta_robot_B_chassis_move">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
]

let Posture = [
  {
    rightnavs: '姿势',
    id: 'gta_robot_B_arm_recenter',
    title: '机械臂回到初始位置',
    content:
      '机械臂回到初始位置;bool ：回中完成返回True，否则返回False;初始位置坐标点为（12，15）。',
    blockText: `<block type="gta_robot_B_arm_recenter">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_arm_move_to',
    title: ' 移动机械臂到绝对位置',
    content:
      '移动机械臂到绝对位置：X（）Y（）。X轴取值范围为12~18的整数值；Y轴取值范围为3~19的整数值；但是由于机器臂的动作的局限，机械臂移动不到在X、Y活动区间的一些的位置，比如机器臂可能移动不到（13,18）位置。',
    blockText: `<block type="gta_robot_B_arm_move_to">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_gripper_close',
    title: '机械手闭合',
    content: '机械手闭合。参数：无。返回bool ：机械手关闭为True，否则为False。',
    blockText: `<block type="gta_robot_B_gripper_close">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_gripper_open',
    title: '机械手打开',
    content: '机械手打开。参数：无。返回bool ：机械手打开为True，否则为False',
    blockText: ` <block type="gta_robot_B_gripper_open">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_servo_move_to',
    title: '舵机旋转',
    content:
      '旋转舵机。参数：a.左舵机：旋转范围范围0~180，其中80-180效果一样：b.右舵机，范围0~180，其中0-90效果一样； 返回bool ：移动成功返回 True, 否则返回 False。',
    blockText: `<block type="gta_robot_B_servo_move_to">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
]

// let Light = [
//   {
//     rightnavs: '灯光',
//     id: 'gta_robot_B_led_set_led',
//     title: '开启RGB灯光',
//     content: '开启RGB灯光。返回bool ： 设置成功返回 True, 设置失败返回 False。',
//     blockText: `<block type="gta_robot_B_led_set_led">
//     <value name="ROBOT">
//       <shadow type="gta_robot"></shadow>
//     </value>
//   </block>`,
//   },
// ]

let Camera = [
  {
    rightnavs: '摄像头',
    id: 'gta_robot_B_display_video',
    title: '打开摄像头',
    content: '主程序运行过程中开启服务，持续显示图像。',
    blockText: `<block type="gta_robot_B_display_video">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    rightnavs: '摄像头',
    id: 'gta_robot_B_get_camera_image',
    title: '获取摄像头图像',
    content:
      '获取当前摄像头的图像，返回网络图片地址。参数：无。返回：网络地址URL。',
    blockText: `<block type="gta_robot_B_get_camera_image">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
]

let Skill = [
  {
    rightnavs: '技能',
    id: 'gta_robot_B_detect_color_blob',
    title: '检测色块区域',
    content:
      '检测图像中是否有指定HSV范围内的色块的线段，如有则返回True 和数组[X1,Y1,X2,Y2]（指代线段起点坐标与终点坐标）。参数：下边界：HSV颜色值，上边界：HSV颜色值，停止：几秒后停止。',
    blockText: `<block type="gta_robot_B_detect_color_blob">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
    <value name="LOW">
      <shadow type="gta_ai_event_item"> </shadow>
    </value>
    <value name="HIGH">
      <shadow type="gta_ai_event_item"> </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_hsv',
    title: 'HSV色块',
    content: 'HSV色块,输出hsv颜色值。参数H色调、S饱和度、V明度。输出HSV值。',
    blockText: `<block type="gta_robot_hsv"></block>`,
  },
  {
    id: 'gta_robot_B_move_along_line',
    title: '自动巡线',
    content: '自动巡线。参数：无。返回bool :巡线结束返回True，异常返回False。',
    blockText: `<block type="gta_robot_B_move_along_line">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_detect_pattern',
    title: '检测图案',
    content: `检测图案。参数：a.图案:支持图案'A'-'Z'，'0'~'9',b.几秒后停止。返回bool :检测到指定图案返回True，未检测到返回False。`,
    blockText: `<block type="gta_robot_B_detect_pattern">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_detect_face',
    title: '检测人脸',
    content: `检测人脸。参数：几秒后停止。`,
    blockText: `<block type="gta_robot_B_detect_face">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_robot_B_detect_qrcode',
    title: '检测二维码',
    content: `检测二维码。参数：几秒后停止。`,
    blockText: `<block type="gta_robot_B_detect_qrcode">
    <value name="ROBOT">
      <shadow type="gta_robot"></shadow>
    </value>
  </block>`,
  },
]

export default {
  Inits,
  Events,
  Control,
  Operators,
  Variable,
  Function,
  Motion,
  // Light,
  Posture,
  Camera,
  Skill,
}
